<form [formGroup]="editTenantForm" (ngSubmit)="onSubmit()">
    <div class="dialog-header">
        <h2 class="dialog-title">Edit Tenant</h2>
        <button class="cancel-button" mat-button type="button" [disabled]="isSubmitting()"
            (click)="onCancel()">Cancel</button>
    </div>

    <div class="dialog-body">
        <mat-dialog-content class="dialog-form">
            <div class="form-section">
                <h3 class="section-title">Tenant Information</h3>
                <mat-form-field>
                    <mat-label>Tenant Name</mat-label>
                    <input matInput formControlName="tenantName" maxlength="200" />
                    @if (editTenantForm.get('tenantName')?.hasError('required')) {
                    <mat-error>Tenant name is required.</mat-error>
                    }
                </mat-form-field>

                <mat-form-field>
                    <mat-label>Tenant Alias</mat-label>
                    <input matInput formControlName="tenantAlias" maxlength="200" />
                    @if (editTenantForm.get('tenantAlias')?.hasError('required')) {
                    <mat-error>Tenant alias is required.</mat-error>
                    }
                </mat-form-field>

                <mat-form-field>
                    <mat-label>Marketplace Subscription ID</mat-label>
                    <input matInput formControlName="marketplaceSubscriptionId" />
                    @if (!editTenantForm.get('marketplaceSubscriptionId')?.value) {
                    <mat-hint>Leave blank if not applicable.</mat-hint>
                    }
                </mat-form-field>
            </div>

            <mat-divider class="section-divider"></mat-divider>

            <div class="form-section">
                <h3 class="section-title">Data Collection</h3>
                <div class="feature-toggle-card">
                    <div class="feature-toggle-text">
                        <mat-icon class="material-symbols-outlined feature-toggle-icon">location_on</mat-icon>
                        <div class="feature-toggle-copy">
                            <p class="feature-toggle-title">Collect User Location</p>
                            <p class="feature-toggle-description">
                                Collection of user location data for analytics
                            </p>
                        </div>
                    </div>
                    <mat-slide-toggle formControlName="collectUserLocation"></mat-slide-toggle>
                </div>
            </div>

            <mat-divider class="section-divider"></mat-divider>

            <div class="form-section">
                <h3 class="section-title">Features</h3>
                <div class="feature-toggle-grid">
                    <div class="feature-toggle-card">
                        <div class="feature-toggle-text">
                            <mat-icon class="material-symbols-outlined feature-toggle-icon">dashboard</mat-icon>
                            <div class="feature-toggle-copy">
                                <p class="feature-toggle-title">Dashboards</p>
                                <p class="feature-toggle-description">
                                    Analytics dashboards and data visualisation tools
                                </p>
                            </div>
                        </div>
                        <mat-slide-toggle formControlName="hasDashboardsAccess"></mat-slide-toggle>
                    </div>

                    <div class="feature-toggle-card">
                        <div class="feature-toggle-text">
                            <mat-icon class="material-symbols-outlined feature-toggle-icon">slideshow</mat-icon>
                            <div class="feature-toggle-copy">
                                <p class="feature-toggle-title">Presentations</p>
                                <p class="feature-toggle-description">
                                    Presentation creation and sharing capabilities
                                </p>
                            </div>
                        </div>
                        <mat-slide-toggle formControlName="hasPresentationsAccess"></mat-slide-toggle>
                    </div>

                    <div class="feature-toggle-card">
                        <div class="feature-toggle-text">
                            <mat-icon
                                class="material-symbols-outlined feature-toggle-icon">network_intelligence</mat-icon>
                            <div class="feature-toggle-copy">
                                <p class="feature-toggle-title">Cognition</p>
                                <p class="feature-toggle-description">
                                    AI-powered insights using custom agentic services
                                </p>
                            </div>
                        </div>
                        <mat-slide-toggle formControlName="hasCognitionAccess"></mat-slide-toggle>
                    </div>
                </div>
            </div>

            @if (submissionErrorMessage()) {
            <mat-error class="error-message">{{ submissionErrorMessage() }}</mat-error>
            }

            <div class="dialog-body-actions">
                @if (showCognitionWarning()) {
                <div class="cognition-warning">
                    <mat-icon class="material-symbols-outlined info-icon">info</mat-icon>
                    <span>Initialisation of Cognition may take up to a minute.</span>
                </div>
                }
                <button class="submit-button" mat-flat-button color="primary" type="submit"
                    [disabled]="editTenantForm.invalid || isSubmitting() || !hasFormChanges()">
                    @if (!isSubmitting()) {
                    Save Changes
                    } @else {
                    <div class="loading-spinner"><app-loading-spinner [strokeWidth]="3"></app-loading-spinner></div>
                    }
                </button>
            </div>
        </mat-dialog-content>
    </div>
</form>